var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-row",
    [
      _c(
        "v-col",
        {
          attrs: {
            cols: "12"
          }
        },
        [
          _c(
            "v-card",
            {
              staticClass: "app-card"
            },
            [
              _c("v-card-title", [
                _c(
                  "span",
                  {
                    staticClass: "title"
                  },
                  [_vm._v("Services List")]
                )
              ]),
              _c(
                "v-card-text",
                [
                  _c("p", [
                    _vm._v("This is the list of services for which "),
                    _c("b", [_vm._v(_vm._s(_vm.accountDetails.email))]),
                    _vm._v(" has an access.")
                  ]),
                  _c("v-data-table", {
                    attrs: {
                      headers: _vm.headers,
                      items: _vm.accountServices
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "item.name",
                        fn: function fn(_ref) {
                          var item = _ref.item
                          return [_vm._v(" " + _vm._s(item.name) + " ")]
                        }
                      },
                      {
                        key: "item.groupname",
                        fn: function fn(_ref2) {
                          var item = _ref2.item
                          return [_vm._v(" " + _vm._s(item.groupname) + " ")]
                        }
                      },
                      {
                        key: "item.domain",
                        fn: function fn(_ref3) {
                          var item = _ref3.item
                          return [_vm._v(" " + _vm._s(item.domain) + " ")]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }